var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import styles from './Settings.module.scss';
import { getAuth, signOut } from "firebase/auth";
import ArrowLeft from '../../assets/box-arrow-left.svg';
import Preloader from '../../assets/preloader.svg';
import { useTypedTranslation } from "../../hooks/useTypedTranslation";
const SignOutButton = () => {
    const [load, setLoad] = useState(false);
    const { t } = useTypedTranslation();
    const handleClick = () => __awaiter(void 0, void 0, void 0, function* () {
        setLoad(true);
        const auth = getAuth();
        setTimeout(() => {
            signOut(auth).then(() => {
                console.log('signout');
            }).catch((error) => {
                console.log(error.code);
            }).finally(() => setLoad(false));
        }, 1500);
    });
    return (_jsx("button", { className: styles.button, onClick: handleClick, children: !load ?
            _jsxs("div", { className: styles.button__content, children: [_jsx(ArrowLeft, {}), _jsx("span", { children: t('logOut') })] })
            :
                _jsx(Preloader, {}) }));
};
export default SignOutButton;
